export function linear(t) {
  return +t;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-ease/src/linear.js
// module id = null
// module chunks = 